import {
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import { UserTypeEnum } from "@validereinc/domain";
import React from "react";

export const UserListFilterPanel = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  return (
    <>
      <FilterPanel
        storageKey={filterConfigStorageKey}
        defaultValue={{
          type: [UserTypeEnum.human, UserTypeEnum.machine],
        }}
        filters={[
          {
            component: (
              <TextInput
                key="name"
                name="name"
                placeholder="Search Users"
                type="search"
                isInline
              />
            ),
          },
        ]}
      />
    </>
  );
};
